import { SIGNAL } from "@angular/core/primitives/signals";
import { environment } from "../../../environments/environment";

const buildUrl = (path: string) => `${environment.apiUrl}${path}`;
const buildWSUrl = (path: string) => `${environment.wsUrl}${path}`;

export const API_ROUTES = {
    AUTH: {
        // POST
        APP_TOKEN: buildUrl('/auth/app-token'),
        SEND_TEMP_PASSWORD: buildUrl('/auth/send-temp-password'),
        RESEND_TEMP_PASSWORD: buildUrl('/auth/resend-temp-password'),
        VERIFY_TEMP_PASSWORD: buildUrl('/auth/verify-temp-password'),
        LOGIN: buildUrl('/auth/login'),
        LOGOUT: buildUrl('/auth/logout'),
        REGISTER: buildUrl('/auth/register'),
        REQUEST_VERIFY_TOKEN: buildUrl('/auth/request-verify-token'),
        VERIFY: buildUrl('/auth/verify'),
        FORGOT_PASSWORD: buildUrl('/auth/forgot-password'),
        RESET_PASSWORD: buildUrl('/auth/reset-password'),
        MFA_SEND: buildUrl('/auth/mfa/send'),
        MFA_RESEND: buildUrl('/auth/mfa/resend'),
        MFA_VERIFY: buildUrl('/auth/mfa/verify'),

        // GET
        GOOGLE_AUTHORIZE: buildUrl('/auth/google/authorize'),
        GOOGLE_CALLBACK: buildUrl('/auth/google/callback'),
        LINKEDIN_AUTHORIZE: buildUrl('/auth/linkedin/authorize'),
        LINKEDIN_CALLBACK: buildUrl('/auth/linkedin/callback'),
        ASSOCIATE_GOOGLE_AUTHORIZE: buildUrl('/auth/associate/google/authorize'),
        ASSOCIATE_GOOGLE_CALLBACK: buildUrl('/auth/associate/google/callback'),
        ASSOCIATE_LINKEDIN_AUTHORIZE: buildUrl('/auth/associate/linkedin/authorize'),
        ASSOCIATE_LINKEDIN_CALLBACK: buildUrl('/auth/associate/linkedin/callback'),
    },
    COMPANY: {
        DEFAULT: buildUrl('/company/'),
        ATECO_CODES: buildUrl('/company/ateco-codes')
    },
    USER: {
        UPLOAD_IMAGE: buildUrl('/users/upload_image/'),
        ME: buildUrl('/users/me'),
        SETTINGS_ID: buildUrl('/users/settings/'),
        INVITE_LINK: buildUrl('/users/invite-link'),
        INVITE_LINK_ID: buildUrl('/users/invite-link/'),
        DELETE_REQUEST: buildUrl('/users/me/delete-request'),
        DELETE_CANCEL: buildUrl('/users/me/delete-cancel'),
    },
    LOCATION: {
        DEFAULT: buildUrl('/location'),
        ALL: buildUrl('/location/all'),
        ELECTRECITY_INVOICES: buildUrl('/location/electricity/invoices/latest'),
        GAS_INVOICES: buildUrl('/location/gas/invoices/latest'),
        CREATE: buildUrl('/location/'),
        POD: buildUrl('/location/pod'),
        PDR: buildUrl('/location/pdr'),
        CONSUMPTION: buildUrl('/location/all/consumption'),
    },
    OPTIMIZATION: {
        ELECTRICITY: buildUrl('/optimization/electricity'),
        GAS: buildUrl('/optimization/gas'),
    },
    FILES: {
        DEFAULT: buildUrl('/files/'),
        UPLOAD: buildUrl('/files/upload'),
        DOWNLOAD: buildUrl('/files/download/'),
        FULL_DATA: buildUrl('/files/admin/details'),
        VIEW_PDF: buildUrl('/files/view/pdf/'),
        PDF_URL: buildUrl('/files/pdf-url/'),
        FILES_IN_EXTRACTION_COUNT: buildUrl('/files/in-extraction-count'),
        ELECTRICITY_FILES_IN_EXTRACTION_COUNT: buildUrl('/files/in-extraction-count/electricity'),
        GAS_FILES_IN_EXTRACTION_COUNT: buildUrl('/files/in-extraction-count/gas'),
        REUPLOAD_EMAIL: buildUrl('/files/reupload/send-email'),
    },
    SERVICES: {
        INSIGHTS: 'https://solar.googleapis.com/v1/buildingInsights:findClosest',
        DATA_LAYERS: 'https://solar.googleapis.com/v1/dataLayers:get',
        PV_CALCULATIONS: buildUrl('/services/pv/calculate'),
    },
    MARKET_DATA:
    {
        ELECTRICITY: buildUrl('/market-data/electricity'),
        ELECTRICITY_ID: buildUrl('/market-data/electricity/'),
        GAS: buildUrl('/market-data/gas'),
        GAS_ID: buildUrl('/market-data/gas/'),
    },
    INVOICES:
    {
        ELECTRICITY: buildUrl('/invoice/electricity'),
        GAS: buildUrl('/invoice/gas'),
        ELECTRICITY_FULL_UPDATE: buildUrl('/invoice/full-update/electricity'),
        GAS_FULL_UPDATE: buildUrl('/invoice/full-update/gas'),
        GAS_PDR_LOCATION_UPDATE: buildUrl('/invoice/gas/pdr/location-view/update'),
        ELECTRICITY_POD_LOCATION_UPDATE: buildUrl('/invoice/electricity/pod/location-view/update'),
        PROCESSING_RESULT_ELECTRICITY: buildUrl('/invoice/processing-result/electricity'),
        PROCESSING_RESULT_GAS: buildUrl('/invoice/processing-result/gas'),
        REVIEW_ELECTRICITY: buildUrl('/invoice/review/electricity'),
        REVIEW_ELECTRICITY_REVIEWED_ONLY: buildUrl('/invoice/review/electricity/reviewed-only'),
        REVIEW_ELECTRICITY_ALL: buildUrl('/invoice/review/electricity/all'),
        REVIEW_GAS: buildUrl('/invoice/review/gas'),
        REVIEW_GAS_REVIEWED_ONLY: buildUrl('/invoice/review/gas/reviewed-only'),
        REVIEW_GAS_ALL: buildUrl('/invoice/review/gas/all'),
        REVIEW_ADMIN_CHANGES_LOG: buildUrl('/invoice/review/admin-changes-log'),
        REVIEW_SEND_EMAIL: buildUrl('/invoice/review/send-email'),
        ELECTRICITY_SINGLE: buildUrl('/invoice/electricity/single'),
        GAS_SINGLE: buildUrl('/invoice/gas/single'),
        ADDITIONAL_NOTE_FILEDS_ELECTRICITY: buildUrl('/invoice/additional-note-fields/electricity'),
        ADDITIONAL_NOTE_FILEDS_GAS: buildUrl('/invoice/additional-note-fields/gas'),
        ELECTRICITY_BY_FILE: buildUrl('/invoice/electricity/by-file'),
        GAS_BY_FILE: buildUrl('/invoice/gas/by-file'),
        REVIEW_ELECTRICITY_UPDATE_BY_FILE: buildUrl('/invoice/review/electricity/update-by-file'),
        REVIEW_GAS_UPDATE_BY_FILE: buildUrl('/invoice/review/gas/update-by-file'),
        REVIEW_BIMESTRALE_BY_FILE: buildUrl('/invoice/review/bimestrale/by-file'),
        REVIEW_BIMESTRALE_UPDATE: buildUrl('/invoice/review/bimestrale/update'),
    },
    ARCHIVE:
    {
        ELECTRICITY_CONTRACTS: buildUrl('/archive/electricity/contracts'),
        ELECTRICITY_INVOICES: buildUrl('/archive/electricity/invoices'),
        GAS_CONTRACTS: buildUrl('/archive/gas/contracts'),
        GAS_INVOICES: buildUrl('/archive/gas/invoices'),
        FILE_COUNTS: buildUrl('/archive/file-counts'),
        UNCATEGORIZED_FILES: buildUrl('/archive/uncategorized/files'),
        RETRY: buildUrl('/archive/retry')
    },
    DASHBOARD:
    {
        TOTAL_CONSUMPTION_AND_COSTS: buildUrl('/dashboard/total-consumption-and-costs/'),
        LOCATIONS_PRICES_OVERIVEW: buildUrl('/dashboard/locations/prices-overview/'),
        LOCATIONS_PRICES_OVERIVEW_PERIOD: buildUrl('/dashboard/locations/prices-overview/period'),
        LOCATION: buildUrl('/dashboard/location/'),
        ELECTRICITY_OVERVIEW: buildUrl('/dashboard/electricity/overview/'),
        ELECTRICITY_CONSUMPTION_AND_COSTS: buildUrl('/dashboard/electricity/consumptions-and-costs/'),
        ELECTRICITY_PERIOD_COSTS_ANALYSIS: buildUrl('/dashboard/electricity/period-cost-analysis/'),
        GAS_OVERVIEW: buildUrl('/dashboard/gas/overview/'),
        GAS_CONSUMPTION_AND_COSTS: buildUrl('/dashboard/gas/consumptions-and-costs/'),
        GAS_PERIOD_COSTS_ANALYSIS: buildUrl('/dashboard/gas/period-cost-analysis/'),
        INVOICES_OLDEST: buildUrl('/dashboard/invoices/oldest'),
        ELECTRICITY_INVOICES_OLDEST: buildUrl('/dashboard/electricity/invoices/oldest'),
        GAS_INVOICES_OLDEST: buildUrl('/dashboard/gas/invoices/oldest'),
        INVOICES_LATEST_FORECAST: buildUrl('/dashboard/invoices/forecast/latest'),
        ELECTRICITY_LATEST_FORECAST_INVOICES: buildUrl('/dashboard/electricity/invoices/forecast/latest'),
        GAS_LATEST_FORECAST_INVOICES: buildUrl('/dashboard/gas/invoices/forecast/latest'),
    },
    PAYMENT:
    {
        MEMBERSHIP: buildUrl('/payment/membership'),
        PLANS: buildUrl('/payment/payment_plans'),
        BILLING_HISTORY: buildUrl('/payment/billing-history'),
        CUSTOMER: buildUrl('/payment/customer'),
        CUSTOMER_PORTAL: buildUrl('/payment/customer/portal'),
        PAYMENT_METHODS: buildUrl('/payment/customer/payment-methods'),
        PAYMENT_METHOD: buildUrl('/payment/customer/payment-method'),
        SUBSCRIPTION_CREATE: buildUrl('/payment/subscription/create'),
        SUBSCRIPTION_UPDATE_PLAN: buildUrl('/payment/subscription/update-plan'),
        SUBSCRIPTION_CANCEL: buildUrl('/payment/subscription/cancel'),
        SUBSCRIPTION_RESUME: buildUrl('/payment/subscription/resume'),
        SUBSCRIPTION_ACTIVE: buildUrl('/payment/subscription/active'),
        SUBSCRIPTION_COST: buildUrl('/payment/subscription/cost'),
        UPDATE_PAYMENT_METHOD: buildUrl('/payment/subscription/update-payment-method'),
        COUNTRY_CODES: buildUrl('/payment/country-codes-list'),
        PROMOTION_CODE_DETAILS: buildUrl('/payment/promotion/details'),
        ASSIGN_PROMOTION_CODE: buildUrl('/payment/promotion/assign-to-user'),
        PROMOTION_CODE_LIST: buildUrl('/payment/promotion/list'),
        LOCATION_PLANS: buildUrl('/payment/location/payment_plans'),
        LOCATION_PAYABLE: buildUrl('/payment/location/payable'),
    },
    NOTIFICATIONS:
    {
        WS: buildWSUrl('/notifications/ws'),
        SEND_TO_ME: buildUrl('/notifications/send-notification/me'),
    },
    SALES_AGENTS:
    {
        DEFAULT: buildUrl('/sales-agents/'),
        PERIOD: buildUrl('/sales-agents/period'),
    },
    ADMIN:
    {
        DEFAULT: buildUrl('/admin/'),
        JSON_GENERATOR_ELECTRICITY: buildUrl('/admin/json-generator/electricity'),
        JSON_GENERATOR_GAS: buildUrl('/admin/json-generator/gas'),
        EXTRACTION_HISTORY: buildUrl('/file-extraction/extraction/history'),
        EXTRACTION: buildUrl('/file-extraction/extraction'),
        QA_STATS: buildUrl('/admin/qa/stats'),
        QA_STATS_OVERVIEW: buildUrl('/admin/qa/stats/overview'),
        QA_FILE: buildUrl('/admin/qa/file'),
        QA_AI_SUMMARY: buildUrl('/admin/qa/ai-summary'),
        QA_FIELD_ERRORS: buildUrl('/admin/qa/field-errors'),
    },
    INDICATOR:
    {
        DEFAULT: buildUrl('/indicator/'),
        VARIABLES: buildUrl('/indicator/variables')
    },
    PRODUCT:
    {
        DEFAULT: buildUrl('/product/'),
    },
    SIGNAL:
    {
        DEFAULT: buildUrl('/signal/'),
    },
    OPPORTUNITY:
    {
        DEFAULT: buildUrl('/opportunity/'),
        FULL: buildUrl('/opportunity/full'),
        COMPANY_OPPORTUNITIES: buildUrl('/opportunity/company-opportunities'),
    },
    FILES_MANAGEMENT:
    {
        DOWNLOAD: buildUrl('/files_management/download'),
        UPLOAD_GAS_TAXES: buildUrl('/files_management/upload/gas-taxes'),
        GET_GAS_TAXES: buildUrl('/files_management/gas-taxes/latest'),
        UPLOAD_GAS_DISTRIBUTION_TARIFF: buildUrl('/files_management/upload/distribution-tariff-gas'),
        GET_GAS_DISTRIBUTION_TARIFF: buildUrl('/files_management/distribution-tariff-gas/latest'),
        UPLOAD_ACCISE_GAS: buildUrl('/files_management/upload/accise-gas'),
        GET_ACCISE_GAS: buildUrl('/files_management/accise-gas/latest'),
        UPLOAD_ELECTRICITY_AND_GAS_PRICES: buildUrl('/files_management/upload/electricity-gas-prices'),
        GET_ELECTRICITY_AND_GAS_PRICES: buildUrl('/files_management/electricity-gas-prices/latest'),
        UPLOAD_ATECO_CURVES: buildUrl('/files_management/upload/ateco-curves'),
        GET_ATECO_CURVES: buildUrl('/files_management/ateco-curves/latest'),
        UPLOAD_CURVE_DATA: buildUrl('/files_management/upload/curve-data'),
        GET_CURVE_DATA: buildUrl('/files_management/curve-data/latest'),
        UPLOAD_TARIFF_TABLE_EE: buildUrl('/files_management/upload/tariff-table-ee'),
        GET_TARIFF_TABLE_EE: buildUrl('/files_management/tariff-table-ee/latest'),
        UPLOAD_DISTRIBUTION_TARIFF_EE: buildUrl('/files_management/upload/distribution-tariff-ee'),
        GET_DISTRIBUTION_TARIFF_EE: buildUrl('/files_management/distribution-tariff-ee/latest'),
    },
};
